import { render } from "./CostumersView.vue?vue&type=template&id=1baf7835"
import script from "./CostumersView.vue?vue&type=script&lang=js"
export * from "./CostumersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__